import EventView from "@/components/Pages/Plan/Molecules/EventView/index.vue";
import Vue, { PropType } from "vue";
import { getErrorMessages } from "@/helpers/api-helper";
import { BadRequestError } from "@/api/types";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  props: {
    projectPeriodObject: {
      type: Object as PropType<ContainerProps["projectPeriodObject"]>,
      required: true
    }
  },
  data() {
    return {
      messages: []
    };
  },
  methods: {
    async handleClickSubmit(recruitmentEvent) {
      try {
        this.$emit("submit");
        const partnerUser = this.$store.state.domains.user.partnerUser;
        const planId = this.$route.params["planId"];
        if (!partnerUser || !planId) {
          return;
        }
        //@ts-ignore
        await this.$store.dispatch("domains/plan/createEvent", {
          partner_id: partnerUser.partner.id,
          plan_id: Number(planId),
          recruitmentEvent
        });
        this.handleClickCreateEventViewClose();
        this.$emit("submit");
      } catch (error) {
        if (error instanceof BadRequestError) {
          this.messages = getErrorMessages(error);
        }
        throw error;
      }
    },
    handleClickCreateEventViewClose() {
      this.$store.commit("pages/plan/updateCreateEventView", {
        isVisible: false
      });
    },
    handlePressEsc(eventDataChanged: boolean) {
      if (!eventDataChanged) {
        this.handleClickCreateEventViewClose();
        return;
      }
      this.$store.commit("pages/plan/updateConfirmDestroyView", {
        isVisible: true
      });
    }
  },
  render(createElement) {
    return createElement(EventView, {
      on: {
        clickSubmit: this.handleClickSubmit,
        clickEventViewClose: this.handleClickCreateEventViewClose,
        pressEsc: this.handlePressEsc
      },
      props: {
        messages: this.messages,
        projectPeriodObject: this.projectPeriodObject
      }
    });
  }
});
